import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-bureau',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bureau.component.html',
  styleUrl: './bureau.component.scss',
})
export class BureauComponent {}
